import { Component, createElement } from "react";
import PropTypes from "prop-types";

function round(x, n) {
    const tenN = Math.pow(10, n);
    return Math.round(x * tenN) / tenN;
}

const defaultProps = {
    getPosition: location => location,
    renderWhileDragging: true,
    dotRadius: 4,
    getColor: location => "#1FBAD6",
    globalOpacity: 1,
    compositeOperation: "source-over",
};

const contextTypes = {
    viewport: PropTypes.object,
    isDragging: PropTypes.bool,
};

export default class ScatterplotOverlay extends Component {
    componentDidMount() {
        this._redraw();
    }

    componentDidUpdate() {
        this._redraw();
    }

    _redraw() {
        const { viewport, isDragging } = this.context;
        const {
            dotRadius,
            compositeOperation,
            renderWhileDragging,
            data,
            getPosition,
            getColor,
        } = this.props;

        const pixelRatio = window.devicePixelRatio || 1;
        const canvas = this.refs.overlay;
        const ctx = canvas.getContext("2d");

        ctx.save();
        ctx.scale(pixelRatio, pixelRatio);
        ctx.clearRect(0, 0, viewport.width, viewport.height);
        ctx.globalCompositeOperation = compositeOperation;

        if ((renderWhileDragging || !isDragging) && data) {
            for (const location of data) {
                const pixel = viewport.project(getPosition(location));
                const pixelRounded = [round(pixel[0], 1), round(pixel[1], 1)];
                if (
                    pixelRounded[0] + dotRadius >= 0 &&
                    pixelRounded[0] - dotRadius < viewport.width &&
                    pixelRounded[1] + dotRadius >= 0 &&
                    pixelRounded[1] - dotRadius < viewport.height
                ) {
                    ctx.fillStyle = getColor(location);
                    ctx.beginPath();
                    ctx.arc(
                        pixelRounded[0],
                        pixelRounded[1],
                        dotRadius,
                        0,
                        Math.PI * 2
                    );
                    ctx.fill();
                }
            }
        }

        ctx.restore();
    }

    render() {
        const {
            viewport: { width, height },
        } = this.context;
        const { globalOpacity } = this.props;
        const pixelRatio = window.devicePixelRatio || 1;
        return createElement("canvas", {
            ref: "overlay",
            width: width * pixelRatio,
            height: height * pixelRatio,
            style: {
                width: `${width}px`,
                height: `${height}px`,
                position: "absolute",
                pointerEvents: "none",
                opacity: globalOpacity,
                left: 0,
                top: 0,
            },
        });
    }
}

ScatterplotOverlay.displayName = "ScatterplotOverlay";
ScatterplotOverlay.defaultProps = defaultProps;
ScatterplotOverlay.contextTypes = contextTypes;



// WEBPACK FOOTER //
// ./src/components/tracking-map/scatterplot-overlay.js